import { createContext } from 'react';

const PhoneReportsContext = createContext();
PhoneReportsContext.displayName = 'PhoneReportsContext';

export default PhoneReportsContext;
